'use strict';

import { queryFirst, queryAll, hasClass, remove } from './domUtil';
const { returnsPageTemplates } = require('./templates');
const $body = $('body');

/**
 * Injects an error message into the provided Return Form
 * @param {Element} form - Specific Return form to inject the error messaging
 * @param {string} message - Error message to display
 */
function injectFormError(form, message) {
    const errorHtml = returnsPageTemplates.errorMessage(message || returnsPageTemplates.defaultError);
    const errorContainer = queryFirst('.form-error-container', form);
    errorContainer.innerHTML = errorHtml;
}

/**
 * Clears the form error messages for both the return form and the gift return forms
 */
function clearFormErrors() {
    const errorAlerts = queryAll('.return-form-container .custom-error-alert');
    remove(errorAlerts);
}

$body.on('click', '.open-gift-return-form, .open-return-form', (e) => {
    const { target } = e;
    if (hasClass(target, 'open-gift-return-form')) {
        queryFirst('.js-gift-return-select').click();
    } else {
        queryFirst('.js-return-select').click();
    }
});

// Clear form error messages when switching between forms
$body.on('click', '.return-nav-tabs a:not(".active")', () => {
    clearFormErrors();
});

// Clear form error messages when focusing on a form input
$body.on('focus', '.return-form input, .gift-return-form input', () => {
    clearFormErrors();
});

$('.return-form, .gift-return-form').submit(async e => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const url = form.action;
    clearFormErrors();
    $body.spinner().start();
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });
        const data = await response.json();
        $body.spinner().stop();
        if (data.success && data.redirectURL) {
            window.location.href = data.redirectURL;
        } else {
            injectFormError(form, data.errorMessage);
        }
    } catch (ex) {
        $body.spinner().stop();
        injectFormError(form);
    }
});

/* Once the page has loaded, check for "orderNumber", "zipCode", and "isGift" in the URL query
and auto-submit the form if they are present */
$(document).ready(() => {
    const { search: urlParams } = window.location;
    if (!urlParams) return;
    const listParams = new URLSearchParams(urlParams);
    const orderNumber = listParams.get('orderNumber');
    const zipCode = listParams.get('zipCode');
    const isGift = listParams.get('isGift');
    if (orderNumber && zipCode) {
        let returnFormNumber;
        let returnFormZip;
        let submitReturnButton;
        if (isGift === 'true') {
            const giftTab = queryFirst('.js-gift-return-select');
            $(giftTab).trigger('click');
            returnFormNumber = queryFirst('#gift-return-form-number');
            returnFormZip = queryFirst('#gift-return-form-zip');
            submitReturnButton = queryFirst('.gift-return-form .lookup-return-btn');
        } else {
            returnFormNumber = queryFirst('#return-form-number');
            returnFormZip = queryFirst('#return-form-zip');
            submitReturnButton = queryFirst('.return-form .lookup-return-btn');
        }
        returnFormNumber.value = orderNumber;
        returnFormZip.value = zipCode;
        $(submitReturnButton).trigger('click');
    }
});
